import Menu from "../assets/images/menu.svg";
import { useNavigate } from "react-router-dom";
export default function Header({ toogleClicked }) {
  const navigate = useNavigate();
  const signout = () => {
    localStorage.removeItem("admin_token");
    navigate("/");
  };
  return (
    <header class="header">
      <div class="w-100 d-flex align-items-center">
        <div class="menu-btn" onClick={toogleClicked}>
          <img src={Menu} alt="menu" />
        </div>
        <div class="dropdown ms-auto">
          <div class="text-center pb-2">
            <a href="#" onClick={signout} class="btn signout-btn">
              Sign out
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
